import axios from 'axios'
import { getAccessToken, getUrl } from 'src/services/AppContext'
import { getMockScenario } from 'src/services/utils/mock-scenario.utils'
import { CUSTOM_HEADERS } from 'src/tpbp-core/models/common.const'

declare module 'axios' {
  export interface AxiosRequestConfig {
    useTpbpPrefix?: boolean
    preventFormatUrl?: boolean
    omitToken?: boolean
  }
}

/**
 * Standard HTTP Client for non-JSON:API calls.
 * Implements ADR-002: Centralizes authentication, URL prefixing and standard headers.
 */
const apiClient = axios.create({
  headers: {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-store, no-cache',
    Pragma: 'no-cache',
  },
})

// Request Interceptor: Auth, URL formatting and Mocking
/* eslint-disable no-param-reassign */
apiClient.interceptors.request.use((config) => {
  // 1. Inject Authorization header if token exists
  const token = getAccessToken()
  if (token && !config.omitToken) {
    config.headers.Authorization = `Bearer ${token}`
  }

  // 2. Format URL with prefixing if it's a relative path
  if (config.url && !config.url.includes('://') && !config.preventFormatUrl) {
    // Default useTpbpPrefix to true for standard business calls as per ADR-002
    const useTpbpPrefix = config.useTpbpPrefix !== false
    config.url = getUrl(config.url, useTpbpPrefix)
  }

  // 3. Inject Mock Scenario header for development/mock modes
  const mockScenario = getMockScenario()
  if (mockScenario) {
    config.headers.set(CUSTOM_HEADERS.MOCK_SCENARIO, mockScenario)
  }

  return config
})
/* eslint-enable no-param-reassign */

// Response Interceptor: Error handling
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // TODO: Centralize error handling (401 retry logic, etc.) if needed
    // For now, we mirror the basic behavior of standard axios
    return Promise.reject(error)
  },
)

export default apiClient
